import type { Template } from '@/models/template';

export interface RecentTemplate {
  uuid: string;
  name: string;
  kind: 'worksheet' | 'report';
  updatedAt: string;
  path: string;
}

/** Worksheets and report templates together, most recently updated first. */
export function recentTemplates(
  worksheets: Template[] | undefined,
  reports: Template[] | undefined,
  limit = 5
): RecentTemplate[] {
  const rows = (
    list: Template[] | undefined,
    kind: RecentTemplate['kind'],
    base: string
  ): RecentTemplate[] =>
    (list ?? []).map(({ uuid, name, updatedAt }) => ({
      uuid,
      name,
      kind,
      updatedAt,
      path: `${base}/${uuid}`,
    }));

  return [
    ...rows(worksheets, 'worksheet', '/templates/worksheets'),
    ...rows(reports, 'report', '/templates/templates'),
  ]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, limit);
}
